/**
 * Create System Setting context for custom hook
 */
import { createContext } from 'react'

const DepartmentsContext = createContext({
  fetchDepartments: () => {}
})

export default DepartmentsContext
